// extracted by mini-css-extract-plugin
export default {"data":"styles_data__yvZs5","infoPairs":"styles_infoPairs__jnwpL","reattributeButton":"styles_reattributeButton__zVL4W"};